import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
var headingStyles = function headingStyles(index) {
  return css(["display:inline-block;", ";font-weight:700;", ";"], getFont(index, 'compact'), function (_ref) {
    var center = _ref.center;
    return center ? 'text-align: center;' : null;
  });
};
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1bigw9a-0"
})(["display:block;margin-top:18px;margin-bottom:", ";text-align:left;", ";"], function (props) {
  return props.bottomMargin ? '18px' : '0';
}, minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-top: 0;\n    text-align: right;\n  "]))));
export var StyledPercentLabel = styled.div.withConfig({
  displayName: "partials__StyledPercentLabel",
  componentId: "sc-1bigw9a-1"
})(["display:block;", ";", ";", ";"], headingStyles(2), minMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n  "])), headingStyles(5)), minMediaQueries.phablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-top: 0;\n  "]))));
export var Label = styled.div.withConfig({
  displayName: "partials__Label",
  componentId: "sc-1bigw9a-2"
})(["display:block;color:rgb(0 0 0 / 0.25);"]);